var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerUtdanningSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.65,17.72a2.79,2.79,0,1,1,2.79-2.79A2.8,2.8,0,0,1,16.65,17.72Zm0-4.89a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,16.65,12.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.48,17.72a2.79,2.79,0,1,1,2.78-2.79A2.8,2.8,0,0,1,23.48,17.72Zm0-4.89a2.1,2.1,0,1,0,2.09,2.1A2.1,2.1,0,0,0,23.48,12.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.48,
    cy: 14.94,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.64,
    cy: 14.94,
    r: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.65,13.37a.32.32,0,0,1-.29-.17.34.34,0,0,1,.11-.47c1.06-.64,1.13-2.34,1.1-3.16A20.29,20.29,0,0,1,20,11.29a17.31,17.31,0,0,1-7.43-1.7,3.48,3.48,0,0,0,1.18,3.14.34.34,0,1,1-.4.56,4.21,4.21,0,0,1-1.44-4,.5.5,0,0,1,.73-.39A16.54,16.54,0,0,0,20,10.59a19.64,19.64,0,0,0,7.53-1.76.52.52,0,0,1,.47,0,.49.49,0,0,1,.24.4c.08.93.08,3.16-1.41,4.07A.41.41,0,0,1,26.65,13.37Zm1.17-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.07,20l-.08,0c-1.69-.39-2.21-2.72-2.23-2.82l0-.14.08-.12c.68-1,1.44-1.59,2.25-1.55a3.12,3.12,0,0,1,2.21,1.54l.07.11,0,.13a3.42,3.42,0,0,1-2.16,2.84Zm-1.6-2.85c.12.45.58,1.82,1.58,2.13a2.8,2.8,0,0,0,1.56-2.15C21.41,16.8,20.79,16,20,16,19.49,16,19,16.37,18.47,17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.5,32.05l-.22-.23c-.15-.17-3.67-4.08-4.2-8.91-.29-2.68.17-5.88,1.88-6.53.76-.29,2-.14,3.77,2.25a.35.35,0,0,1-.57.41c-1.14-1.59-2.19-2.31-3-2-1.13.43-1.74,2.93-1.43,5.81a17.18,17.18,0,0,0,3.81,8.27c3.66-3,2.4-7.92,2.38-8a.35.35,0,0,1,.25-.43.34.34,0,0,1,.42.25c0,.05,1.45,5.61-2.88,8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.81,32.05l-.26-.19C21.22,28.57,22.66,23,22.67,23a.34.34,0,0,1,.42-.25.35.35,0,0,1,.25.43c0,.05-1.27,4.95,2.38,8,.76-.93,3.38-4.33,3.81-8.27.32-2.88-.3-5.38-1.43-5.81-.77-.3-1.82.42-3,2a.36.36,0,0,1-.49.08.35.35,0,0,1-.07-.49c1.72-2.39,3-2.55,3.77-2.25,1.7.65,2.16,3.85,1.87,6.53-.53,4.83-4,8.74-4.2,8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.21,31.83a4.64,4.64,0,0,1-3.9-2.11.35.35,0,0,1,.6-.35,4,4,0,0,0,3.35,1.77,3.54,3.54,0,0,0,3.13-1.72.34.34,0,0,1,.46-.15.35.35,0,0,1,.16.46,4.2,4.2,0,0,1-3.74,2.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerUtdanningSmall);
export default __webpack_public_path__ + "static/media/Ikoner_Utdanning_small.77fafabe661df9699f53c5ddd61efef2.svg";
export { ForwardRef as ReactComponent };